import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";
import {useMatchersSkusForm} from "../../@hooks";

const OPTIONS = [
	{label: "Female", value: 1 },
    { label: "Male", value: 2 },
    { label: "Unisex", value: 3 },
]

export default function MatchersSKUsDrawerGender() {
	const { localValue, handleChange } = useMatchersSkusForm('gender')

    return <SelectSeeker
		options={OPTIONS}
		isClearable
		label="Gender"
		placeholder="Please select a gender"
		value={localValue || ''}
		onChange={newValue => handleChange(newValue.target.value)}
	/>
}
